module.exports = __webpack_public_path__ + "static/img/my_position.211ba74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/my_position.png
// module id = ./src/assets/my_position.png
// module chunks = 1